export const PRODUCT_TOUR_VERSION = 3;

export interface AccountProfile {
  firstName: string;
  lastName: string;
  birthdate: string | null;
  productTourVersion: number;
}

export interface UpdateAccountProfileRequest {
  firstName: string;
  lastName: string;
  birthdate: string;
}

export interface CompleteProductTourRequest {
  version: number;
}
